export default function () {
	return {
		activities: [],
    	downloading: false
	}
}
